'use strict';
document.addEventListener('DOMContentLoaded', initPopupImages);

function initPopupImages() {

    let images = document.querySelectorAll(`.popup-image`);

    for (let image of images)
        image.onclick = function() {zoomImage(image.src)};

}

let zoomImage = (path) => {

    let img = `<img src="${path}" alt="Увеличенное изображение"/>`;
    popup.open();
    popup.insertData(img);

}
